<template>
  <BModal
    :model-value="show"
    :title="`収集日設定: ${formattedDate}`"
    ok-title="保存"
    cancel-title="キャンセル"
    @ok="handleSave"
    @hide="$emit('close')"
  >
    <!-- 選択中のごみ種別 -->
    <div class="mb-3">
      <label class="form-label fw-bold">選択中のごみ種別</label>
      <div v-if="localWasteTypes.length === 0" class="text-muted p-2 border rounded bg-light text-center">
        設定なし
      </div>
      <ul v-else class="list-group">
        <li
          v-for="(type, index) in localWasteTypes"
          :key="index"
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          {{ type.typeName }}
          <button class="btn btn-sm btn-outline-danger" @click="removeWasteType(index)">
            <i class="bi bi-trash"></i>
          </button>
        </li>
      </ul>
    </div>

    <!-- ごみ種別を追加 -->
    <div class="mb-3">
      <label class="form-label fw-bold">ごみ種別を追加</label>
      <div class="d-flex gap-2">
        <select class="form-select" v-model="selectedWasteTypeId">
          <option value="" disabled selected>ごみ種別を選択</option>
          <option v-for="type in availableWasteTypes" :key="type.id" :value="type.id">
            {{ type.typeName }}
          </option>
        </select>
        <button class="btn btn-primary" @click="addWasteType" :disabled="!selectedWasteTypeId">
          <i class="bi bi-plus-lg"></i> 追加
        </button>
      </div>
    </div>
  </BModal>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { BModal } from 'bootstrap-vue-next'

const props = defineProps({
  show: Boolean,
  date: Date,
  currentWasteTypes: {
    type: Array,
    default: () => []
  },
  allWasteTypes: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['close', 'save'])

const localWasteTypes = ref([])
const selectedWasteTypeId = ref('')

const formattedDate = computed(() => {
  if (!props.date) return ''
  const d = new Date(props.date)
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
})

const availableWasteTypes = computed(() => {
  const selectedIds = localWasteTypes.value.map(t => t.id)
  return props.allWasteTypes.filter(t => !selectedIds.includes(t.id))
})

watch(() => props.show, (newVal) => {
  if (newVal) {
    localWasteTypes.value = JSON.parse(JSON.stringify(props.currentWasteTypes))
    selectedWasteTypeId.value = ''
  }
})

const addWasteType = () => {
  if (!selectedWasteTypeId.value) return

  const wasteType = props.allWasteTypes.find(t => t.id === selectedWasteTypeId.value)
  if (wasteType) {
    localWasteTypes.value.push(wasteType)
    selectedWasteTypeId.value = ''
  }
}

const removeWasteType = (index) => {
  localWasteTypes.value.splice(index, 1)
}

const handleSave = () => {
  emit('save', {
    date: props.date,
    wasteTypes: localWasteTypes.value
  })
}
</script>
